import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpennebulaComponent } from './simple-icons-opennebula.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpennebulaComponent ],
    exports:      [ SimpleIconsOpennebulaComponent ],
    bootstrap:    []
})
export class SimpleIconsOpennebulaModule {}
